import * as logo from "./logo";
import * as ranking from "./ranking";
import * as sidebar from "./sidebar";

import * as all from "./all";
import * as account from "./account";
import * as tiers from "./tiers";

import * as brokers from "./broket";
import * as social from "./social";
import * as investments from "./investments";

export const iconsSet = Object.assign({
  ...investments,
  ...logo,
  ...ranking,
  ...sidebar,
  ...all,
  ...account,
  ...tiers,
  ...brokers,
  ...social,
});
